<template>
  <div class="page">
    
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">  {{ 'newProductEndTitle' | lang }}</div>
     
      <button  @click="goTo('/cart', null, true)" >
        <i class="fa fa-fw fa-shopping-cart" :badge="cartLengthLabel"></i>
      </button>

      
    </header> 
    <!-- <stepper :steps="steps" :step="step"  />-->
    <div class="noheader" v-if="buying && buyingSafe.ticketInfo">

   
      <select-user v-if="manifest.manageRelativeUser==true && buying.ticketInfo.MediaType=='csc' && buying.ticketInfo.ProductType=='mediaProduct'"
      v-bind:usercode="usercode"
       v-on:update:usercode="usercode = $event"
      ></select-user>

    <p>{{ 'product' | lang }}: {{buyingSafeTicketInfo.Title}}</p>
    <p>{{buyingSafeTicketInfo.TitleProductDetail}} </p>
      <!-- <p v-if="infos.Origin && infos.Destination && infos.Origin.Label && infos.Destination.Label">{{ 'TripResume' | lang(null, { from: infos.Origin.Label, to: infos.Destination.Label})}} <span v-if="infos.Via && infos.Via.Label">{{ 'TripResume2' | lang(null, { via: infos.Via.Label }) }}</span></p> -->
      <p v-if="infos.Origin && infos.Destination && infos.Origin.Label && infos.Destination.Label">
        {{ 'From' | lang }}
        <br />
        {{infos.Origin.Label}}
        <br />
        {{ 'to' | lang }}
        <br />
        {{infos.Destination.Label}}

        <template v-if="infos.Via && infos.Via.Label">
          <br />
          {{ 'via' | lang }}
          <br />
          {{infos.Via.Label}}<span v-if="infos.Viabis && infos.Viabis.Label">, {{infos.Viabis.Label}}</span>
        </template>
        <!-- {{ 'TripResume' | lang(null, { from: infos.Origin.Label, to: infos.Destination.Label})}} <span v-if="infos.Via && infos.Via.Label">{{ 'TripResume2' | lang(null, { via: infos.Via.Label }) }}</span> -->
      </p>
      <p v-if="luggageVehicleSafe">{{luggageVehicleSafe.type + '_tripresume' | lang}}<br />{{luggageVehicleSafe.label}}</p>
      <div class="form-row" v-if="askQuantity">
        <label>{{ 'Quantity' | lang }}</label>
        <count-selector v-model="qta" :min="1" />
      </div>
      <p v-if="qta > 1">{{ 'Price' | lang }}: {{ (buyingSafeTicketInfo.Amount / 100) | currency }}&nbsp;X&nbsp;{{qta}} = {{ (buyingSafeTicketInfo.Amount / 100) * qta | currency }}</p>
      <p v-else>{{ 'Price' | lang }}: <i class="fa fa-fw fa-refresh fa-spin" v-if="priceLoading"></i><span v-else>{{ (buyingSafeTicketInfo.Amount / 100) | currency }}</span></p>
      <p v-if="buyingSafe.csc">{{ 'buyOnCsc' | lang(null, { number: buyingSafe.csc.MediaSerialNumber }) }}</p>

      <div v-for="(doc, idx) in documentsNeeded" :key="idx">
        {{doc.EvidenceType.Label}}<br/>
        <label class="asButton">
          <input type="file" @change="chooseFile($event, idx)" :accept="manifest.document.acceptFormats" /><!--image/jpg,image/jpeg,image/png,application/pdf-->
          <p v-if="chosenFiles[idx]">{{chosenFiles[idx].name || '-'}}</p>
          <p v-if="chosenFiles[idx]">{{chosenFiles[idx].size | humanFileSize}}</p>
        </label>
      </div>
    </div>
    <div v-else>&nbsp;</div>
    <footer class="flexrow">

      <button @click="addToCart(false)" :disabled="adding || !allDocumentChosen || !usercode || usercode===''">{{ 'Add' | lang }}</button>
      <button v-if="this.buying.ticketInfo.MediaType!='csc'" @click="addToCart(true)" :disabled="adding || !allDocumentChosen || !usercode || usercode===''" >{{ 'addAndPay' | lang }}</button>
      <button v-if="this.buying.ticketInfo.MediaType=='csc'" @click="addToCart(true)" :disabled="adding || !allDocumentChosen || !usercode || usercode===''">{{ 'addAndGotCart' | lang }}</button>
    </footer>
  
</div>
</template>

<script>
import page from '@/mixins/routeControl'
import databaseWrapperMixin from '@/mixins/databaseWrapperMixin'
import CountSelector from '@/components/CountSelector'
import SelectUser   from '@/components/SelectUser' 
import cartServices from '@/mixins/services/cartServices'
import saleableServices from '@/mixins/services/saleableServices'
import SimpleDialog from '@/dialogs/SimpleDialog'
import { create } from 'vue-modal-dialogs'
//import Stepper from '@/components/Stepper.vue';
import userServices from '@/mixins/services/userServices'

const simpleDialogCreator = create(SimpleDialog)

export default {
  name: 'ProductEnd',
  mixins: [ page, databaseWrapperMixin, cartServices, saleableServices,userServices ],
  components: { CountSelector ,SelectUser/*Stepper*/},
  data () {
    return {
      qta: 1,
      price: 0,
      usercode:"",
      buyingCopy: null,
      adding: false,
      priceLoading: false,
      chosenFiles: [],
    //  steps:[],
    //   step:1,

    }
  },
  computed: {
    product () {
      return this.buying.ticketInfo
    },
    buyingSafe () {
      return this.buying || this.buyingCopy || { ticketInfo: {} }
    },
    buyingSafeTicketInfo () {
      if (this.buyingSafe && this.buyingSafe.ticketInfo) {
        return this.buyingSafe.ticketInfo
      }
      return {}
    },
    luggageVehicleSafe () {
      if (!(this.buyingSafeTicketInfo && this.buyingSafeTicketInfo.ItemLuggageVehicleWeightInfo)) {
        return null
      }
      return {
        label: this.buyingSafeTicketInfo.ItemLuggageVehicleWeightInfo.InfoLuggageWeightVehicle.Description,
        type: this.buyingSafeTicketInfo.ItemLuggageVehicleWeightInfo.ObjectType
      }
    },
    infos () {
      if (this.buying && this.buying.ticketInfo && this.buying.ticketInfo.ItemOdTravelsInfo && this.buying.ticketInfo.ItemOdTravelsInfo.Travel && this.buying.ticketInfo.ItemOdTravelsInfo.Travel.length) {
        return this.buying.ticketInfo.ItemOdTravelsInfo.Travel[0]
      }
      return { Origin: {}, Destination: {}, Via: {} }
    },
    askQuantity () {
      return this.buying && this.buying.toBeAsked && this.buying.toBeAsked.indexOf('quantity') > -1
    },
    documentsNeeded () {
      if (this.buyingSafeTicketInfo.EvidenceInfo && this.buyingSafeTicketInfo.EvidenceInfo.EvidenceNumber) {
        return this.buyingSafeTicketInfo.EvidenceInfo.Evidences
      }
      return null
    },
    allDocumentChosen () {
      if (this.documentsNeeded) {
        for (let i = 0; i < this.documentsNeeded.length; i++) {
          if (!(this.chosenFiles[i] && this.chosenFiles[i].name)) {
            return false
          }
        }
      }
      return true
    }
  },
  methods: {

    getShippingAddress()
    {
      var address=null;
      if(this.userProfile.profilo.AddressInfo.length==1)
        {
          address=this.userProfile.profilo.AddressInfo[0];
        }
        else if(this.userProfile.profilo.AddressInfo.length>1)
        {
          for(var i=0;i<this.userProfile.profilo.AddressInfo.length;i++)
          {
            if(this.userProfile.profilo.AddressInfo[i].IsCustomerPrimaryAddress==false)
            {
              address=this.userProfile.profilo.AddressInfo[i];
            }
          }     
        }
      return address;
    },
    async chooseFile (evt, idx) {
      let maxsize = this.manifest.document.maxSize;// in KB
      let allowedTypes =this.manifest.document.acceptFormats.split(',') ;
      let files = evt.srcElement.files
      let file = null
      if (files && files.length) {
        file = files[0]
      }
      if (file.size > 1024*maxsize) {
        evt.target.value = null
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('excessive_file_size', { maxsize }),
          key: this.notifierKey,
          timeout: 3000
        })
        return
      }     
    const name=file.name;
    const lastDot = name.lastIndexOf('.');
    const extension = "."+ name.substring(lastDot + 1).toLowerCase();
      if (!allowedTypes.includes(extension)) {
        evt.target.value = null
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('documentFormatNotValid', null, { formats: this.manifest.document.acceptFormats }),
          key: this.notifierKey,
          timeout: 5000
        })
        return
        }
      if (!file) {
        return
      }

      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })

      this.$set(this.chosenFiles, idx, file)

      let nameArray = file.name.split('.')
      let ext = nameArray.length > 1 ? nameArray[nameArray.length - 1] : file.type.split('/')[1]
      this.documentsNeeded[idx].Documents = [{
        DataFile: await toBase64(file),
        Name: file.name,
        Type: ext,
        Id: 0
      }]
      this.documentsNeeded[idx].Documents[0].DataFile = this.documentsNeeded[idx].Documents[0].DataFile.split(';base64,')[1]

    },
    async addToCart (close) {
      if (!this.user.Email) {
        let email = await simpleDialogCreator({ input: 'Email', inputType: 'email', text: this.dictValue('InsertYourMail'), required: true })
        if (!email) {
          return
        }
        this.user.Email = email
      }

      this.adding = true

      let initial_qta = this.qta
      let sec = this.qta * 3

      while (this.qta > 0 && --sec > 0) {
        try {
        if(this.buying.ticketInfo.MediaType=='csc' && this.buying.ticketInfo.ProductType=='mediaProduct')
        {
          this.buying.ticketInfo.Address=this.getShippingAddress();
        }
          let resp = await this._addToCart(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null,this.usercode)
          console.log('_addToCart resp', resp)
          this.qta--
        } catch (e) {
          console.error(e)
        }
      }

      if(this.qta === 0) {
        this.buyingCopy = JSON.parse(JSON.stringify(this.buying))
        let npages = this.buying.pagecount
        var pay=this.buying.ticketInfo.MediaType!='csc' && close;
        this.buying = { csc: this.buying.csc }
        if (close) {
          this.goTo('/cart/' + pay, true, true)
        } else {
          this.back(npages)
        }
      } else if (this.qta < initial_qta) {
        // partial problem
        this.internalBus.$emit('notify:warn', {
          text: this.dictValue('cart_added_partial'),
          key: this.notifierKey,
          timeout: 3000
        })
      } else {
        // full fail
        this.internalBus.$emit('notify:error', {
          text: this.dictValue('errorOccured'),
          key: this.notifierKey,
          timeout: 3000
        })
      }
      this.adding = false
      

      // this.dwAddToCart(this.buying, this.qta)
    }
  },
  beforeDestroy () {},
  mounted () {
    this.usercode=this.user.UserAccountCode;
    if (!this.buying) {
      this.back() // this.goTo('/products/new', true)
    } else {
      if (this.buying.askPrice) {
        this.priceLoading = true
        this._getPrice(this.buying.ticketInfo, this.buying.csc ? this.buying.csc.MediaSerialNumber : null, this.buying.csc ? this.buying.csc.MediaUnicity : null).then(resp => {
          this.buying.ticketInfo.Amount = resp.Price
          this.priceLoading = false
        }).catch(err => {
          console.error(err)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured') + (err.status === 418 ? '[VAD]' : ''),
            key: this.notifierKey,
            timeout: 3000
          })
        })
      }
    /*  if(this.buying.ticketInfo.MediaType=='csc')
      {
        this.steps=[
        "Selezione Tessera" ,
        "Caricamento Documenti",
        "Scelta Spedizione" ,
        "Conferma ordine"
        ]
      }*/
    }
  },
  watch: {}
}
</script>

<style>


</style>
